import React from 'react';
import styled from 'styled-components';
import { SmallSectionHeader } from 'components/Typography';

export const StyledtBlocWrapper = styled(({ height, ...otherProps }) => (
  <div {...otherProps} />
))`
  height: ${(props) => props.height};
`;

export const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    margin-bottom: 0px;
    letter-spacing: 0;
    line-height: 23px;
  }
`;
